var React = require('react');

function HighlightedBrightAmberIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"1","fill":"#F9C04E","key":0}),React.createElement("path",{"d":"M9.07733 17H7.44664L11.1107 6.81818H12.8856L16.5496 17H14.9189L12.0404 8.66761H11.9608L9.07733 17ZM9.35076 13.0128H14.6405V14.3054H9.35076V13.0128Z","fill":"#0A182E","key":1})]);
}

HighlightedBrightAmberIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = HighlightedBrightAmberIcon;

HighlightedBrightAmberIcon.default = HighlightedBrightAmberIcon;
